import { Component } from 'react';
import Message from '../../modules/Message';

class ShowMessage extends Component {
    constructor(props) {
        super();
        this.deleteMessage = this.deleteMessage.bind(this);

        this.state = {
            message_tags: 'success',
            message: '',
        };
    }

    componentDidMount() {
        window.addEventListener('localStorageChange', (e) => {
            if (e.value.message) {
                this.setState({
                    message_tags: e.value.message_tags,
                    message: e.value.message,
                });
            }
        });
    }

    deleteMessage() {
        this.setState({ message: '', message_tags: '' });
    }

    render() {
        return (
            this.state.message && (
                <div className="messages">
                    <Message
                        message_tags={this.state.message_tags}
                        message={this.state.message}
                        deleteMessage={this.deleteMessage}
                    />
                </div>
            )
        );
    }
}
export default ShowMessage;
